import {useProductsSalesForecastInfo} from '@domain/materials'

import {useUrlParam} from '../../../routing'

export const useProductsSalesForecastInfoQuery = (materialId: number) => {
  const plantCode = useUrlParam('plantCode')
  return useProductsSalesForecastInfo({plantCode, materialId})
}
